export enum OrderSource {
    WEB = 'Web',
    AUTOSHIP = 'AutoShip',
    CSP = 'Agent',
    SMS = 'SMS',
    WALKIN = 'Walk-in',
    EVENT = 'Event',
    INTERNATIONAL = 'International',
    AMAZON = 'Amazon'
}

export enum OrderSourceValue {
    WEB = 1,
    CUSTOMER = 2,
    AUTOSHIP = 3,
    POS =  4
}

export enum OrderSourceTypes {
    CUSTOMERSERVICE = 'Customer Service',
    WEB = 'WEB',
    AUTOSHIP = 'AUTOSHIP',
    AMAZON = 'AMAZON',
    POS = 'POS'
}



// WEBPACK FOOTER //
// ./src/app/customerservice/enums/order-source.enum.ts